import React from "react";
import PageHeader from "../../core/common/header/PageHeader";
import { FaChartBar } from "react-icons/fa";
import MentorBatchWritingTaskSummary from "./MentorBatchWritingTaskSummary";

const MentorBatchWritingTaskResultsPage: React.FC = () => {
  return (
    <div className="min-h-screen bg-gray-100">
      {/* Header */}
      <PageHeader
        icon={<FaChartBar />}
        title="Writing Task Results"
        breadcrumb={[
          { label: "Home", to: "/" },
          { label: "Dashboard", to: "/mentor/dashboard" },
          { label: "Writing Task Results" },
        ]}
      />

      {/* Content */}
      <main className="max-w-7xl mx-auto px-4 sm:px-6 py-8">
        <div className="bg-white rounded-lg shadow-lg p-6">
          <h2 className="text-2xl font-bold text-gray-900 mb-6 flex items-center gap-2">
            <FaChartBar className="text-[#009fe3]" />
            Batch Writing Task Results Overview
          </h2>
          <MentorBatchWritingTaskSummary />
        </div>
      </main>
    </div>
  );
};

export default MentorBatchWritingTaskResultsPage;
